/**
 * @generated SignedSource<<32e8e3b011d12142f3645932c15326a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleShareWidgetArticle$data = {
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "contentShareWidgetContent">;
  readonly " $fragmentType": "articleShareWidgetArticle";
};
export type articleShareWidgetArticle$key = {
  readonly " $data"?: articleShareWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleShareWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleShareWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "9c79707f0e153269c23d9ad9aab32a7d";

export default node;
